import { useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import LoadingSpinner from '../../components/common/loading/LoadingSprinner';
import { all_routes } from '../../../core/data/routes/all_routes';

const ReferralPage = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const BaseUrl = import.meta.env.VITE_APP_BACKEND_AUTH;
  useEffect(() => {
    if (!code) return;

    const handleReferral = async () => {
      try {
        window.location.href = `${BaseUrl}/auth/web/register?ref=${code}&portal=customer&client=web`;
      } catch (error) {
        console.log('Referral tracking error:', error);
      }
    };

    handleReferral();
  }, [code]);

  if (!code) {
    return <Navigate to={all_routes.index} replace />;
  }

  return <LoadingSpinner label="Processing referral..." />;
};

export default ReferralPage;
